module.exports = __webpack_public_path__ + "img/logo.48cd65c5.png";